import React from "react";
import { BrowserRouter } from "react-router-dom";
import AppWrapper from "./AppWrapper";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { SidebarProvider } from "./context/SidebarContext";

const App: React.FC = () => {
  return (
    <div className="App">
      <BrowserRouter>
        <SidebarProvider>
          {/* All admin toasts (react-toastify) — pinned to bottom-center so they don't
              collide with the top filter pills / header on the board and detail pages. */}
          <ToastContainer position="bottom-center" autoClose={4000} hideProgressBar={false} newestOnTop closeOnClick pauseOnHover />
          <AppWrapper />
        </SidebarProvider>
      </BrowserRouter>
    </div>
  );
};

export default App;
